<template>
	<CombinedMaintenanceModal
		:currDevice="currDevice"
		:currReplacement="currReplacement"
		:currPanel="currPanel"
		:currCheck="currCheck"
		:modalTexts="modalTexts"
		:historyData="batteryReplacementHistory"
		:panelHistoryData="panelReplacementHistory"
		:checkHistoryData="technicianCheckHistory"
		:batteryHistoryLoading="batteryHistoryLoading"
		:panelHistoryLoading="panelHistoryLoading"
		:checkHistoryLoading="checkHistoryLoading"
		:initialType="initialType"
		@saveDevice="$emit('saveDevice')"
		@saveMaintenanceRecord="$emit('saveMaintenanceRecord', $event)"
		@closeModal="$emit('closeModal')"
		@validationError="$emit('validationError', $event)"
		@loadMaintenanceHistory="loadHistory"
	/>
</template>

<script>
import CombinedMaintenanceModal from './CombinedMaintenanceModal.vue'
import {
	createMaintenanceRecord,
	buildDeviceMaintenanceFields,
	getDeviceSensorCode,
	getTodayIsoDate,
	MAINTENANCE_HISTORY_CONFIG,
	MAINTENANCE_RECORD_KEYS,
	MAINTENANCE_RECORD_TYPES,
} from '../utils/maintenanceUtils'

function createHistoryState() {
	const state = {
		batteryReplacementHistory: [],
		panelReplacementHistory: [],
		technicianCheckHistory: [],
		batteryHistoryLoading: false,
		panelHistoryLoading: false,
		checkHistoryLoading: false,
		batteryHistoryLoaded: false,
		panelHistoryLoaded: false,
		checkHistoryLoaded: false,
	}

	return state
}

export default {
	name: 'MaintenanceModal',
	inheritAttrs: false,
	props: {
		currDevice: {
			type: Object,
			required: true,
		},
		modalTexts: {
			type: Object,
			required: true,
		},
		initialType: {
			type: String,
			default: 'note',
		},
	},
	data() {
		return {
			currReplacement: createMaintenanceRecord('battery'),
			currPanel: createMaintenanceRecord('panel'),
			currCheck: createMaintenanceRecord('technician'),
			...createHistoryState(),
		}
	},
	computed: {
		loggedUser() {
			return this.$store.getters.loggedUser || {}
		},
		sensorCode() {
			return getDeviceSensorCode(this.currDevice)
		},
	},
	mounted() {
		const today = getTodayIsoDate()
		if (this.currDevice.note && !this.currDevice.note.date) {
			this.currDevice.note.date = today
		}

		this.initializeMaintenanceRecords()

		if (this.initialType === 'battery') {
			this.resetMaintenanceRecord('battery')
			this.loadHistory('battery')
		}
	},
	methods: {
		initializeMaintenanceRecords() {
			const deviceFields = buildDeviceMaintenanceFields(this.currDevice, this.loggedUser)

			for (const type of MAINTENANCE_RECORD_TYPES) {
				Object.assign(this[MAINTENANCE_RECORD_KEYS[type]], deviceFields)
			}
		},
		resetMaintenanceRecord(maintenanceType) {
			const record = createMaintenanceRecord(maintenanceType, {
				...buildDeviceMaintenanceFields(this.currDevice, this.loggedUser),
				note_text: '',
				created_at: null,
			})

			Object.assign(this[MAINTENANCE_RECORD_KEYS[maintenanceType]], record)
		},
		loadHistory(maintenanceType) {
			const config = MAINTENANCE_HISTORY_CONFIG[maintenanceType]
			if (!config) return
			if (this[config.loadedKey] || this[config.loadingKey]) return

			this[config.loadingKey] = true
			this.$emit('loadMaintenanceHistory', {
				sensorCode: this.sensorCode,
				maintenanceType,
				callback: (history, error) => {
					if (error) {
						console.error(`Error loading ${maintenanceType} history:`, error)
						this[config.historyKey] = []
					} else {
						this[config.historyKey] = history
						this[config.loadedKey] = true
					}
					this[config.loadingKey] = false
				},
			})
		},
	},
	components: {
		CombinedMaintenanceModal,
	},
}
</script>
